import { frontendURL } from '../../../../helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

// T-118: merge assistido de contatos duplicados (admin). Merge nunca é automático.
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/duplicados'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'fandata_duplicados',
          meta: {
            permissions: ['administrator'],
          },
          component: Index,
        },
      ],
    },
  ],
};
